//import { FIREBASE_PUBLIC_URL } from '../util/firebase';
//const IMAGE_URL = `${FIREBASE_PUBLIC_URL}/images%2Fcameras%2F{CAMERA_KEY}%2Flatest.png?alt=media`;

export const getCameraThumb = (camera) => {
  return camera.screenshot
  //return IMAGE_URL.replace('{CAMERA_KEY}', camera.key);
};

export const getDistanciaHumanized = (distancia) => {
  return (distancia / 1000) < 0.5 ?
    `${distancia.toFixed(2)}m` :
    `${(distancia/1000).toFixed(2)}km`;
};



// WEBPACK FOOTER //
// ./src/util/camera.js